<template id="repairhist">
  <v-ons-page>
    <custom-toolbar
      :title="'Repair History'"
      :action="toggleMenu"
    ></custom-toolbar>
    <div class="content-box">
      <TableRepairHistory />
    </div>
  </v-ons-page>
</template>

<style scoped>
.content-box {
  text-align: center;
  margin: 60px 25px 25px 25px;
}

.bottom-bar {
  background-color: #4abca5;
  border-top-style: solid;
  border-top-color: #837d89;
  border-top-width: 5px;
}
</style>

<script>
import customToolbar from "./PageNav.vue";
import TableRepairHistory from "./TableRepairHistory.vue";
export default {
  name: "PageRepairHistory",
  template: "repairhist",
  props: ["toggleMenu"],
  components: {
    customToolbar,
    TableRepairHistory,
  },
};
</script>